// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2F25q","title":"Card_title__1IC-6","year":"Card_year__37ksK","user":"Card_user__19y1s"};